<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">小程序商城</el-breadcrumb-item>
        <el-breadcrumb-item>退款管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form" size="default">
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="querys.keyword" prefix-icon="Search" @keyup.enter="fetchs" placeholder="请输入退款单号、订单号或用户手机号"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="退款状态" prop="refundStatus">
          <el-col>
            <el-select v-model="querys.refundStatus" placeholder="请选择退款状态" clearable style="width: 100px;" key="refund-status-select" @change="onRefundStatusChange" value-key="value" filterable>
              <el-option label="全部" value="all"></el-option>
              <el-option label="待审核" value="0"></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="已退款" value="2"></el-option>
              <el-option label="审核拒绝" value="-1"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="退款类型" prop="refundType">
          <el-col>
            <el-select v-model="querys.refundType" placeholder="请选择退款类型" clearable style="width: 100px;" key="refund-type-select" @change="onRefundTypeChange" value-key="value" filterable>
              <el-option label="全部" value="all"></el-option>
              <el-option label="退货退款" value="1"></el-option>
              <el-option label="仅退款" value="0"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="Search" @click="fetchs()">
            搜索
          </el-button>
          <el-button icon="Refresh" @click="resetSearch()" style="margin-left: 10px;">
            重置
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button type="success" icon="Check" @click="auditRefund(currRow)" :disabled="!currRow || currRow.refundStatus !== 0">
        审核
      </el-button>
      <el-button type="warning" icon="Money" @click="handleRefund" :disabled="!currRow || currRow.refundStatus !== 1">
        退款
      </el-button>
      <el-button type="danger" icon="Delete" @click="handleDelete">
        删除
      </el-button>
      <el-button plain icon="Download" @click="exportData()" style="float: right;">导出数据</el-button>
    </div>

    <static-table class="table" :pager="pager" :columns="querys.columns" :currHandler="currHandler"
      :sortHandler="sortHandler" :pageHandler="pageHandler" :sizeHandler="sizeHandler">
      <template v-slot:refundStatus="scope">
        <el-tag :type="getRefundStatusType(scope.row.refundStatus)">
          {{ getRefundStatusText(scope.row.refundStatus) }}
        </el-tag>
      </template>
      <template v-slot:refundType="scope">
        <el-tag :type="scope.row.refundType === 1 ? 'warning' : 'info'">
          {{ scope.row.refundType === 1 ? '退货退款' : '仅退款' }}
        </el-tag>
      </template>
      <template v-slot:orderID="scope">
        <el-button @click="goToOrder(scope.row.orderID)" type="primary" link size="small">
          {{ scope.row.orderID }}
        </el-button>
      </template>
      <template v-slot:toolbar="scope">
        <el-button @click="watchRefund(scope.row)" type="primary" link size="small">
          [查看]
        </el-button>
      </template>
    </static-table>

    <!-- 退款详情弹窗 -->
    <static-dialog ref="detailDialog" class="dialog" title="退款详情" :opened="detailOpened" :okVisible="false" width="70%">
      <div v-if="refundDetail">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-card class="box-card" style="margin-bottom: 20px;">
              <template #header>
                <div class="card-header">
                  <span>退款基本信息</span>
                </div>
              </template>
              <el-row :gutter="10">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">退款单号：</span>
                    <span class="value">{{ refundDetail.refund.refundNo }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">关联订单ID：</span>
                    <span class="value">{{ refundDetail.refund.orderID }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">申请用户ID：</span>
                    <span class="value">{{ refundDetail.refund.userID }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">退款状态：</span>
                    <el-tag :type="getRefundStatusType(refundDetail.refund.refundStatus)">
                      {{ getRefundStatusText(refundDetail.refund.refundStatus) }}
                    </el-tag>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">退款类型：</span>
                    <el-tag :type="refundDetail.refund.refundType === 1 ? 'warning' : 'info'">
                      {{ refundDetail.refund.refundType === 1 ? '退货退款' : '仅退款' }}
                    </el-tag>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">申请时间：</span>
                    <span class="value">{{ refundDetail.refund.createDate }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">申请退款金额：</span>
                    <span class="value">¥{{ refundDetail.refund.refundAmount }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">实际退款金额：</span>
                    <span class="value">¥{{ refundDetail.refund.actualAmount || '未退款' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">退款时间：</span>
                    <span class="value">{{ refundDetail.refund.refundTime || '未退款' }}</span>
                  </div>
                </el-col>
                <el-col :span="8" v-if="refundDetail.refund.refundChannel">
                  <div class="detail-item">
                    <span class="label">退款渠道：</span>
                    <span class="value">{{ refundDetail.refund.refundChannel }}</span>
                  </div>
                </el-col>
                <el-col :span="8" v-if="refundDetail.refund.refundPlatformNo">
                  <div class="detail-item">
                    <span class="label">平台单号：</span>
                    <span class="value">{{ refundDetail.refund.refundPlatformNo }}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="label">退款原因：</span>
                    <span class="value">{{ refundDetail.refund.refundReason || '无' }}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="label">退款说明：</span>
                    <span class="value">{{ refundDetail.refund.refundRemark || '无' }}</span>
                  </div>
                </el-col>
                <el-col :span="24" v-if="refundDetail.refund.auditRemark">
                  <div class="detail-item">
                    <span class="label">审核备注：</span>
                    <span class="value">{{ refundDetail.refund.auditRemark }}</span>
                  </div>
                </el-col>
                <el-col :span="8" v-if="refundDetail.refund.auditUserName">
                  <div class="detail-item">
                    <span class="label">审核人：</span>
                    <span class="value">{{ refundDetail.refund.auditUserName }}</span>
                  </div>
                </el-col>
                <el-col :span="8" v-if="refundDetail.refund.auditDate">
                  <div class="detail-item">
                    <span class="label">审核时间：</span>
                    <span class="value">{{ refundDetail.refund.auditDate }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <span>退款商品明细</span>
                </div>
              </template>
              <el-table :data="refundDetail.details" border style="width: 100%">
                <el-table-column prop="productName" label="商品名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="skuCode" label="SKU编码" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="attributes" label="规格属性" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unitPrice" label="单价" width="80">
                  <template #default="scope">
                    ¥{{ scope.row.unitPrice }}
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" label="退款数量" width="90"></el-table-column>
                <el-table-column prop="refundAmount" label="申请退款金额" width="110">
                  <template #default="scope">
                    ¥{{ scope.row.refundAmount }}
                  </template>
                </el-table-column>
                <el-table-column prop="actualAmount" label="实际退款金额" width="110">
                  <template #default="scope">
                    ¥{{ scope.row.actualAmount || '未退款' }}
                  </template>
                </el-table-column>
                <el-table-column prop="imgSrc" label="商品图片" width="90">
                  <template #default="scope">
                    <el-image 
                      v-if="scope.row.imgSrc" 
                      style="width: 40px; height: 40px" 
                      :src="scope.row.imgSrc" 
                      :preview-src-list="[scope.row.imgSrc]">
                    </el-image>
                    <span v-else>无图片</span>
                  </template>
                </el-table-column>
                <el-table-column prop="expressName" label="快递公司" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="expressNumber" label="快递单号" width="120" show-overflow-tooltip></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </static-dialog>

    <!-- 退款审核弹窗 -->
    <static-dialog ref="auditDialog" class="dialog" title="退款审核" :ok="submitAudit">
      <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="审核结果" prop="auditResult">
              <el-radio-group v-model="auditForm.auditResult">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="-1">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核备注" prop="auditRemark">
              <el-input 
                v-model="auditForm.auditRemark" 
                type="textarea" 
                :rows="4" 
                placeholder="请输入审核备注">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </static-dialog>
  </el-card>
</template>

<script>
import { fetchShopRefundList, fetchShopRefundDetail, auditShopRefund, exportShopRefundDetail, delShopRefund } from "@/api/shop";
import StaticDialog from "@/components/static-dialog.vue";
import StaticTable from "@/components/static-table.vue";

export default {
  name: "refund",
  components: { StaticDialog, StaticTable },
  data() {
    return {
      apiUrl: '',
      querys: {
        keyword: "",
        refundStatus: "all",
        refundType: "all",
        filters: [],
        columns: [
          { type: "index", label: "序号" },
          { prop: "refundNo", label: "退款单号", sortable: true, searchable: true, width: "180", showOverflowTooltip: true },
          { prop: "orderID", label: "关联订单ID", type: "template", sortable: true, searchable: true, width: "200", showOverflowTooltip: true },
          { prop: "refundStatus", label: "退款状态", type: "template", sortable: true, searchable: true, width: "100" },
          { prop: "refundType", label: "退款类型", type: "template", sortable: true, searchable: true, width: "100" },
          { prop: "refundAmount", label: "申请退款金额", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
          { prop: "actualAmount", label: "实际退款金额", sortable: true, searchable: true, width: "120", showOverflowTooltip: true },
          { prop: "refundReason", label: "退款原因", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
          { prop: "createDate", label: "申请时间", sortable: true, searchable: true, width: "140", showOverflowTooltip: true },
          { prop: "auditUserName", label: "审核人", sortable: true, searchable: true, width: "80", showOverflowTooltip: true },
          { prop: "auditDate", label: "审核时间", sortable: true, searchable: true, width: "140", showOverflowTooltip: true },
          { prop: "auditRemark", label: "审核备注", sortable: true, searchable: true, width: "160", showOverflowTooltip: true },
          { type: "toolbar", label: "操作", width: "100", fixed: "right" }
        ],
      },
      pager: {
        sidx: "id",
        sord: "descending",
      },
      currRow: null,
      refundDetail: null,
      auditForm: {
        auditResult: 1,
        auditRemark: '',
        actualAmount: 0
      },
      auditRules: {
        auditResult: [
          { required: true, message: "请选择审核结果", trigger: "change" },
        ],
        auditRemark: [
          { required: true, message: "请输入审核备注", trigger: "blur" },
        ],
      }
    };
  },
  mounted() {
    if (this.$route.query.keyword) {
      this.querys.keyword = this.$route.query.keyword;
    }
    
    this.fetchs();
    this.apiUrl = process.env.VUE_APP_BASEURL;
  },
  methods: {
    fetchs() {
      this.querys.filters = [];
      
      
      if (this.querys.refundStatus !== "" && this.querys.refundStatus !== "all") {
        this.querys.filters.push({
          name: "refundStatus",
          value: this.querys.refundStatus,
          operate: 0,
        });
      }
      
      if (this.querys.refundType !== "" && this.querys.refundType !== "all") {
        this.querys.filters.push({
          name: "refundType",
          value: this.querys.refundType,
          operate: 0,
        });
      }

      let { data, records, total, ...search } = {
        ...this.pager,
        ...this.querys,
      };

      fetchShopRefundList(search).then((res) => {
        this.pager = { ...res.data };
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: '获取退款列表失败：' + (error.message || '未知错误')
        });
      });
    },
    resetSearch() {
      this.querys.keyword = "";
      this.querys.refundStatus = "all";
      this.querys.refundType = "all";
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      this.fetchs();
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.pager.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.pager.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.pager.sidx = order.prop;
      this.pager.sord = order.order;
      this.fetchs();
    },
    getRefundStatusType(status) {
      const statusTypeMap = {
        '-1': 'danger',
        '0': 'warning',
        '1': 'primary',
        '2': 'success'
      };
      return statusTypeMap[status] || 'info';
    },
    getRefundStatusText(status) {
      const statusMap = {
        '-1': '审核拒绝',
        '0': '待审核',
        '1': '审核通过',
        '2': '已退款'
      };
      return statusMap[status] || '未知状态';
    },
    watchRefund(row) {
      let that = this;
      fetchShopRefundDetail(row.refundNo).then((res) => {
        that.refundDetail = res.data;
        that.$refs.detailDialog.toggle();
      }).catch((error) => {
        that.$message({
          type: 'error',
          message: '获取退款详情失败：' + (error.message || '未知错误')
        });
      });
    },
    auditRefund(row) {
      this.currRow = row;
      this.auditForm = {
        auditResult: 1,
        auditRemark: ''
      };
      this.$refs.auditDialog.toggle();
    },
    handleRefund() {
      if (!this.currRow) {
        this.$message({
          type: 'warning',
          message: '请先选择要退款的记录'
        });
        return;
      }
      if (this.currRow.refundStatus !== 1) {
        this.$message({
          type: 'warning',
          message: '只有审核通过的记录才能退款'
        });
        return;
      }
      
      let that = this;
      this.$confirm("之前已审核通过，本次将直接发起退款，是否确认进行退款？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        auditShopRefund(that.currRow.refundNo, 1, '通过').then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });
          that.fetchs();
        }).catch((error) => {
          that.$message({
            type: 'error',
            message: '退款失败：' + (error.message || '未知错误')
          });
        });
      });
    },
    submitAudit() {
      let that = this;
      
      this.$refs.auditForm.validate((valid) => {
        if (!valid) return;

        auditShopRefund(that.currRow.refundNo, that.auditForm.auditResult, that.auditForm.auditRemark).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });

          that.fetchs();
          that.$refs.auditDialog.toggle();
        }).catch((error) => {
          that.$message({
            type: 'error',
            message: '操作失败：' + (error.message || '未知错误')
          });
          that.$refs.auditDialog.toggle();
        });
      });
    },
    handleDelete() {
      if (!this.currRow) {
        this.$message({
          type: 'warning',
          message: '请先选择要删除的退款记录'
        });
        return;
      }
      this.del(this.currRow);
    },
    del(row) {
      this.currRow = row;
      let that = this;

      this.$confirm("此操作将删除本行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delShopRefund(row.id).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });
          if (res.data) {
            that.fetchs();
          }
        });
      });
    },
    exportData() {
      let that = this;
      
      exportShopRefundDetail({}).then((res) => {
        if (res.code === 200) {
          that.$notify({
            title: "导出成功",
            message: res.content,
            type: "success",
            duration: 10000
          });
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
        } else {
          that.$message({
            type: 'error',
            message: res.content || '导出失败'
          });
        }
      }).catch((error) => {
        that.$message({
          type: 'error',
          message: '导出失败：' + (error.message || '未知错误')
        });
      });
    },
    detailOpened() {
    },
    auditOpened() {
    },
    onRefundStatusChange(value) {
      this.querys.refundStatus = value;
    },
    onRefundTypeChange(value) {
      this.querys.refundType = value;
    },
    goToOrder(orderID) {
    // 跳转到订单页面，携带订单ID作为关键词进行搜索
      this.$router.push({
        path: '/shop/order',
        query: {
          orderId: orderID
        }
      });
    }
  },
};
</script>

<style lang="less">
.el-form .el-date-editor {
  width: 220px;
}

.detail-item {
  margin-bottom: 10px;
}

.detail-item .label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.detail-item .value {
  color: #303133;
}

.card-header {
  font-weight: bold;
  font-size: 16px;
}
</style>
